import { DateTime } from 'luxon'

import type { SeriesPageWorldMember } from '@/common/services/seriesPage/types'

import getActiveAnniversary from '@/client/services/user/getActiveAnniversary'
import type { UserAuthRole } from '@/client/services/userRole/types'

import type { UserWithMemberDetails, WorldMemberDetails } from '@/components/Worlds/types'

export type UserWithMemberHost = {
  userId: number
  displayName: string
  username: string | null
  avatarUrl: string | null
  bio: string | null
  roles: UserAuthRole[]
  pronouns: string | null
  timezone: string | null
  memberSince: string | null
  keyClubDistrictName: string | null
  isVerified: boolean
  worldMember: SeriesPageWorldMember | null
}

export function worldMemberDetailsFromHost(
  worldMember: UserWithMemberHost['worldMember']
): WorldMemberDetails | null {
  if (worldMember == null) {
    return null
  }

  return {
    level: worldMember.level ?? 'member',
    joinedAt: DateTime.fromISO(`${worldMember.createdAt}`),
    goal: worldMember.goal,
    snoozeGoalUntil:
      worldMember.snoozeGoalUntil == null ? null : DateTime.fromISO(worldMember.snoozeGoalUntil),
    helpIntents: worldMember.details?.helpIntents ?? [],
  }
}

export default function userWithMemberDetailsFromHost(
  host: UserWithMemberHost
): UserWithMemberDetails {
  const pronouns = host.pronouns ?? ''

  return {
    id: host.userId,
    displayName: host.displayName,
    avatarUrl: host.avatarUrl ?? '',
    username: host.username,
    bio: host.bio ?? '',
    roles: host.roles,
    timezone: host.timezone ?? '',
    pronouns: pronouns.length === 0 ? null : pronouns,
    activeAnniversary: getActiveAnniversary(DateTime.fromISO(`${host.memberSince}`)),
    keyClubDistrictName: host.keyClubDistrictName,
    memberDetails: worldMemberDetailsFromHost(host.worldMember),
    isVerified: host.isVerified,
  }
}
